import React, { useState } from 'react'
import { Redirect } from 'react-router-dom'
import CommWhatsAppPageShell from './CommWhatsAppPageShell'
import WhatsAppInboxPanel from '../whatsapp/WhatsAppInboxPanel'
import '../../css/Admin_css/admin-customize.css'

// Created By Cursor — dedicated Inbox page (CRM-style separate route)
const CommWhatsAppInbox = () => {
  const token = localStorage.getItem('token')
  const [loggedIn] = useState(!!token)

  if (!loggedIn) return <Redirect to="/Login" />

  return (
    <CommWhatsAppPageShell
      title="WhatsApp Inbox"
      breadcrumb="Inbox"
      activeNav="inbox"
    >
      <WhatsAppInboxPanel />
    </CommWhatsAppPageShell>
  )
}

export default CommWhatsAppInbox
